import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import DeviceLogin from "./pages/DeviceLogin"; // Import the DeviceLogin component
import TeacherLogin from "./pages/TeacherLogin"; // Import the TeacherLogin component
import Home from "./pages/Home"; // Import the Home component
import TeacherAuthHandler from "./components/TeacherAuthHandler";

function App() {
  return (
    <Router>
      <TeacherAuthHandler />
      <Routes>
        {/* Device Login Page */}
        <Route path="/" element={<DeviceLogin />} />

        {/* Teacher Login Page (PIN or Email/Password) */}
        <Route path="/teacher-login" element={<TeacherLogin />} />

        {/* Dashboard Page */}
        <Route path="/dashboard" element={<Home />} />

        {/* Redirect to device login if route doesn't match */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
